<template>
  <div class="tags">
    <div v-for="([name, value], index) in tags" :key="index">
      <filter-tag
        v-if="
          value[0] &&
          ((value[0].values && value[0].values.length > 0) ||
            value[0].relative_date ||
            value[0].from)
        "
        :name="name"
        :tag="getTags(value)"
        v-on="$listeners" />
    </div>
    <span class="clear-filter" @click="onClear">Clear Filter</span>
  </div>
</template>

<script>
import FilterTag from "./FilterTag";

export default {
  name: "FilterTags",
  components: { FilterTag },
  props: {
    content: {
      type: Object,
      required: true,
    },
    isFilterOpen: {
      type: Boolean,
      required: true,
    },
    totalFilterCheckBoxCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filterHeight: 0,
    };
  },
  computed: {
    tags() {
      return Object.entries(this.content);
    },
  },
  watch: {
    /**
     * @description
     * both isFilterOpen && totalFilterCheckBoxCount functions added
     * to calculate filterTags height(Required only for floatingScrollBar dont include for common component use.)
     */
    isFilterOpen: function () {
      this.$nextTick(function () {
        this.$emit("onNextTickUpdate");
      });
    },
    totalFilterCheckBoxCount: function () {
      this.$nextTick(function () {
        this.$emit("onNextTickUpdate");
      });
    },
  },
  mounted() {
    /**
     * @description
     * to calculate filterTags height(Required only for floatingScrollBar dont include for common component use.)
     */
    this.$nextTick(function () {
      this.$emit("onNextTickUpdate");
    });
  },
  methods: {
    onClear() {
      this.$emit("onClearFilter");
    },
    getChargeCodeValue(tags) {
      let chargeCodeArray = [];
      tags?.forEach((value) => {
        let chargeCodeValue;
        value.split("+").forEach((item) => {
          chargeCodeValue = chargeCodeValue
            ? chargeCodeValue + "+" + item?.split("-")?.[0]
            : item?.split("-")?.[0];
        });
        chargeCodeArray.push(chargeCodeValue);
      });
      return chargeCodeArray;
    },
    getTags(val) {
      const value = val.map((item) =>
        item.values && item.values.length && item.values[0] === "<BLANK>"
          ? { ...item, values: ["BLANK"] }
          : item
      );
      return value &&
        (value[0].type === "RANGE" || value[0].type === "RELATIVE_DATE_RANGE")
        ? value[0]
        : value[0].property_id === "chargeCode"
        ? this.getChargeCodeValue(value[0].values)
        : value[0].values;
    },
  },
};
</script>

<style lang="scss" scoped>
.tags {
  display: flex;
  margin-bottom: 8px;
  flex-wrap: wrap;
  align-items: center;
  & .clear-filter {
    margin-left: 16px;
    margin-right: 16px;
    // margin-top: 12px;
    font-size: 14px;
    cursor: pointer;
    font-family: "Maersk Headline";
    color: var(--Blue-600-Dark);
    text-decoration: underline;
    line-height: 16px;
  }
}
</style>
